import { render } from "./SelectMask.vue?vue&type=template&id=88e5a754&scoped=true"
import script from "./SelectMask.vue?vue&type=script&lang=js"
export * from "./SelectMask.vue?vue&type=script&lang=js"

import "./SelectMask.vue?vue&type=style&index=0&id=88e5a754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e5a754"]])

export default __exports__